import {
  TStateCommunications,
  createStateSagaCommunications,
} from 'src/helpers/redux'

import { actions as sagaActions, PREFIX } from './actions'
import { IGlobalStore } from 'src/types/store'
import { IGetAvailableNumbersParams } from 'src/services/numbers'
import { IAvailableNumber, PlaceVariables } from './types'
import { IConnectedAccount } from '../account/state'
import { IAccount } from 'src/services/accounts'

export interface IStateData {
  accounts: {
    params: IGetAvailableNumbersParams
    data: IConnectedAccount[]
    cursor: string | null
    item?: IAccount
  }
  availableNumbers?: IAvailableNumber[]
  availableRcNumbers?: IAvailableNumber[]
}

export interface IState {
  communication: TStateCommunications<typeof sagaActions>
  data: IStateData
}

export const initialState: IState = {
  communication: createStateSagaCommunications(sagaActions),

  data: {
    accounts: {
      params: {
        phoneNumberFilterType: PlaceVariables.START_WITH,
        phoneNumberFilterValue: '',
      },
      data: [],
      cursor: null,
      item: undefined,
    },
    availableNumbers: [],
    availableRcNumbers: [],
  },
}

export type TGlobalStateWithService = IGlobalStore & {
  [PREFIX]: IState
}

export { PREFIX }
